import axios from 'axios';
import { endpoint } from '../utils/utils';
import { getusertoken } from './login';

export const guardarHorario = async (usuario, nrcs, periodo) => {
  const data = {
    usuario,
    nrcs,
    periodo,
  };

  try {
    await axios.post(`${endpoint}/horarios/agregar`, data, getusertoken());
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const listahorarios = async (usuario, periodo) => axios.get(`${endpoint}/horarios/listar/${usuario}/${periodo}`, getusertoken());

export const mostrarhorario = async (nrcs, periodo) => axios.get(`${endpoint}/horarios/mostrar/${nrcs}/${periodo}`, getusertoken());

export const eliminarhorario = async (usuario, id, periodo) => axios.delete(`${endpoint}/horarios/eliminar/${usuario}/${id}/${periodo}`, getusertoken());
